/** Spacing token values that map to --spacing-{n} CSS custom properties */
export type SpacingToken =
  | 0
  | 2
  | 4
  | 6
  | 8
  | 10
  | 12
  | 16
  | 20
  | 24
  | 32
  | 40
  | 64
  | 80;

/** Alignment values for layout primitives */
export type LayoutAlign = "start" | "center" | "end" | "stretch" | "baseline";

/** Justification values for layout primitives */
export type LayoutJustify =
  | "start"
  | "center"
  | "end"
  | "between"
  | "around"
  | "evenly";

/** Wrapping behavior for layout primitives */
export type LayoutWrap = "wrap" | "nowrap" | "wrap-reverse";

/** Gap variant classes mapped to spacing tokens */
export const gapVariants = {
  0: "gap-(--spacing-0)",
  2: "gap-(--spacing-2)",
  4: "gap-(--spacing-4)",
  6: "gap-(--spacing-6)",
  8: "gap-(--spacing-8)",
  10: "gap-(--spacing-10)",
  12: "gap-(--spacing-12)",
  16: "gap-(--spacing-16)",
  20: "gap-(--spacing-20)",
  24: "gap-(--spacing-24)",
  32: "gap-(--spacing-32)",
  40: "gap-(--spacing-40)",
  64: "gap-(--spacing-64)",
  80: "gap-(--spacing-80)",
} as const satisfies Record<SpacingToken, string>;

/** Alignment variant classes */
export const alignVariants = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline",
} as const satisfies Record<LayoutAlign, string>;

/** Justification variant classes */
export const justifyVariants = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly",
} as const satisfies Record<LayoutJustify, string>;

/** Wrap variant classes */
export const wrapVariants = {
  wrap: "flex-wrap",
  nowrap: "flex-nowrap",
  "wrap-reverse": "flex-wrap-reverse",
} as const satisfies Record<LayoutWrap, string>;
